import { useEffect, useRef } from 'react';

import {
  useChangeAdditionalParamsMutation,
  useGetMyInfoMutation,
  useLazyExtendedInfoQuery,
} from '@/api/queries/user';
import i18n, { isSystemLanguage } from '@/i18n';
import { changeLoginRequesLoadingStatus } from '@/redux/reducers/appReducer';
import { changeOnboardingStatus } from '@/redux/reducers/userReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

const useGetMyInfoAfterLogin = (): void => {
  const token = useAppSelector((state) => state.user.token);
  const hasRequestSend = useRef<boolean>(false);
  const [getMyInfo] = useGetMyInfoMutation();
  const [getExtendedInfo] = useLazyExtendedInfoQuery();
  const [changeAdditionalParams] = useChangeAdditionalParamsMutation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const initDataIsExist = !!Telegram?.WebApp?.initData;

    if (token && !initDataIsExist && !hasRequestSend.current) {
      hasRequestSend.current = true;
      getMyInfo()
        .unwrap()
        .then((response) => {
          dispatch(changeOnboardingStatus(true));
          getExtendedInfo();

          if (!isSystemLanguage) {
            i18n.changeLanguage(response.language);
          } else if (response.language !== i18n.language) {
            // Язык системы главнее серверного — синхронизируем, чтобы
            // уведомления/бот приходили на том же языке.
            changeAdditionalParams({ language: i18n.language });
          }
        })
        .finally(() => dispatch(changeLoginRequesLoadingStatus(false)));
    }
  }, [token]);
};

export { useGetMyInfoAfterLogin };
